import { createSlice } from "@reduxjs/toolkit";
import Run from "types/Run.type";
import { logout } from "./actions";
import dayjs from "dayjs";

const initialState: { runs: Run[] } = {
  runs: []
};

export const recentSlice = createSlice({
  name: "recent",
  initialState,
  reducers: {
    addRecentRun: (state, action) => {
      if (
        dayjs()
          .subtract(6, "day")
          .startOf("day")
          .isSameOrBefore(action.payload.runStartTime)
      ) {
        state.runs = state.runs
          .filter((run) => run.id !== action.payload.id)
          .slice(0, 9);
        state.runs.unshift(action.payload);
      }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  }
});

export const { addRecentRun } = recentSlice.actions;
export default recentSlice.reducer;
